import { Component, Input } from '@angular/core';
import { SystemInfo } from '@platform/platform.state';
import { CustomerSpace } from '@core/core.state';
import { parseFullSemanticalVersionFromInformationalVersion } from './version-parse';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @Input() customerSpace?: CustomerSpace;
  @Input() systemInfo?: SystemInfo | null;

  get version() {
    return parseFullSemanticalVersionFromInformationalVersion(this.systemInfo?.informationalVersion);
  }
}
